function personView() {

    self = this;

    leadOptions = {
            title : 'entity_lead_source',
            heading: 'leads',
            url: 'leadsource'
    };
    opportunitiesOptions = {
            title : 'entity_program_opportunities',
            heading: 'program_opportunity',
            url: 'opportunity'
    };
    applicationsOptions = {
            title : 'entity_applications',
            heading: 'application'
            ,url: 'application'
    };

    self.mainPersonArea = ko.observableArray(new Array(new mainPersonArea(
            leadOptions), new mainPersonArea(opportunitiesOptions),
            new mainPersonArea(applicationsOptions)));

}

function mainPersonAreaItem(options) {
    if(jQuery.isEmptyObject(options.score)){
        options.score='';
    }
    this.id = options.id;
    this.pageId = options.id;
    this.title = ko.observable(options.sourceDetailName);
    this.date = options.capturedOn;
    this.score = ko.observable(options.score);
    this.scoreComputed= ko.computed(function(){
        if (this.score()=='')
            return "---";
        return this.score();
    },this);

    this.circle = ko.computed(function(){
        return 'c100 green p'+this.score()+' small';
    },this);

    if (!options.urlPrefix) {
        this.urlPrefix = 'lead/lead';
    } else {
        this.urlPrefix = options.urlPrefix;
    }
    if (!options.type) {
        this.type = 'editLead';
    } else {
        this.type = options.type;
    }
    this.formActive = ko.observable(false);
    this.titleName = ko.observable(false);
    this.submitMessage = ko.observable(false);
    this.submitMessageText = ko.observable('');
    this.showPrimaryConfirmDialog = ko.observable(false); // for showing confirmation dialog for converting to primary
    this.isPrimary = ko.observable(false); // this makes lead primary
    this.isPrimaryCheck = ko.observable(false); // bound to primary checkbox value
    this.showPrimaryCheckBox = ko.observable(true); // control show and hide of primary checkbox

}

function mainPersonArea(options) {
    var self = this;
    self.title = options.title;
    self.heading = options.heading;
    self.url = options.url || false;
    self.items = ko.observableArray();
    if (options.items) {
        self.items = options.items;
    }
    self.newItem = function() {

        // add new items if it does nto already exist in the array

        newItemExists = jQuery.grep(this.items(), function(a) {
            return a.id == 'new';
        });

        if (newItemExists.length == 0) {
            newItem = new mainPersonAreaItem({
                id : 'new',
                sourceDetail : '',
                capturedOn : '',
                score : ''
            });

            this.items.unshift(newItem);
        }
        // navigate to the new page
        pager.navigate('#' + self.getRoute() + '/new');
    };
    self.getRoute = function() {
        return pager.page.route.slice(0, 4).join('/');
    };
}

function passwordView() {
    var self = this;    
    self._count = 0;
    self._submitMessage = ko.observable(false);
    self._submitMessageCountdown = ko.observable(0);
    self._errorCount = ko.observable(0);
    self._errorRequiredList = ko.observableArray([]);
    self._errorInvalidList = ko.observableArray([]);
    self._errorInvalidEmail = ko.observableArray([]);
    self._errorRequiredListToggle = ko.observable(false);
    self._errorInvalidListToggle = ko.observable(false);
    self._saveMessage = ko.observable(0);    
    self.username = ko.observable('');
    self.password1 = ko.observable('');
    self.password2 = ko.observable('');
    self.validToken = ko.observable(-1);
    self.errorLoginSso = ko.observable(false);
    self.formPostData = ko.observableArray([]);

    self.validateEmail = function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };
    
    
    self.scrollTop =  function (index) {
        $('input[name='+index+']').focus();
        return false;
    };
    
    self.toggleErrorRequiredList = function() {
        if (self._errorRequiredListToggle() == true) {
            self._errorRequiredListToggle(false);
        } else {
            self._errorRequiredListToggle(true);
        }
    };

    self.toggleErrorInvalidList = function() {
        if (self._errorInvalidListToggle() == true) {
            self._errorInvalidListToggle(false);
        } else {
            self._errorInvalidListToggle(true);
        }
    };
    
    self.reset = function(formElement){
        self._count = 0;       
        self._errorCount = ko.observable(0);
        self._errorRequiredList = ko.observableArray([]);
        self._errorInvalidList = ko.observableArray([]);
        $(formElement).find('.error').remove();
        $(formElement).find('.mandatory-text').remove();
    };
    
    self.errorRequiredListToggleClass = ko.computed (function () {
        return self._errorRequiredListToggle() ? 'icon icon-arrow-down' : 'icon icon-arrow-right'
     }, this);

     self.errorInvalidListToggleClass = ko.computed (function () {
         return self._errorInvalidListToggle() ? 'icon icon-arrow-down' : 'icon icon-arrow-right'
      }, this);
    
     self.hideErrors = function(data, e) {
         $(e.target).parents('.validate').find('.error').remove();
         $(e.target).parents('.validate').find('.mandatory-text').remove();
     };
   
    self.resetPasswordEnterKeyEvent = function(formElement , event){
		if (event.which == 13) {
            this.submit(formElement);
		}
		return true;
    };
    self.changePasswordValue = function(){
        self.validatePasswordNewPolicy();
        return true;
    };

    self.submit = function() {
        if ($('#response-error').length > 0) {
            $('#response-error').remove();
        }
        self._errorCount(0);
        self._errorRequiredList([]);
        self._errorInvalidList([]);
        self._errorInvalidEmail([]);
        self._errorRequiredListToggle(false);
        self._errorInvalidListToggle(false);
        $('#login-form').find('.error').remove();
        $('#login-form').find('.mandatory-text').remove();
        var hasUpperCase = /[A-Z]/.test(self.password1());
        var hasLowerCase = /[a-z]/.test(self.password1());
        var hasNumbers = /\d/.test(self.password1());
        var hasSpecialCharacters = /[!@#$%^&*()\\_+.]/.test(self.password1());
        //$('.password-guide > span').attr("style","color:light");
		 if (self.username() === '') {
			var error_message = jQuery.i18n.prop('message_email_address_required');
			$('#user').parents('.validate').find('.error').remove();
			$('#user').parents('.validate').find('.mandatory-text').remove();
			$('#user').parents('.validate').append("<p class='mandatory-text'><span>" + error_message + "</span></p><div class='error invalid'></div>"); 
			self._errorCount(self._errorCount() + 1);
			self._errorRequiredList.push({label:jQuery.i18n.prop('label_email'), index: 'user'});
		 } else if (!self.validateEmail(self.username())) {
		    var error_message = jQuery.i18n.prop('message_email_address_entered_is_not_valid');
			$('#user').parents('.validate').find('.error').remove();
			$('#user').parents('.validate').find('.mandatory-text').remove();
			$('#user').parents('.validate').append("<p class='mandatory-text'><span>" + error_message + "</span></p><div class='error invalid'></div>"); 
			self._errorCount(self._errorCount() + 1);
			self._errorInvalidEmail.push({label:jQuery.i18n.prop('label_email'), index: 'user'});
		 }

		 if (self.password1() == '') {
		     var error_message = jQuery.i18n.prop('message_set_password_required');
		     $('#password').parents('.validate').find('.error').remove();
		     $('#password').parents('.validate').find('.mandatory-text').remove();
		     $('#password').parents('.validate').append("<p class='mandatory-text'><span>" + error_message + "</span></p><div class='error required'></div>"); 
		     self._errorCount(self._errorCount() + 1);
		     self._errorRequiredList.push({label:jQuery.i18n.prop('label_new_password'), index: 'password'});
		 
		 } else if (self.password1().length < 10 || (!hasUpperCase || !hasLowerCase || !hasNumbers || !hasSpecialCharacters)) {
            var error_message = jQuery.i18n.prop('message_set_password_error_wrong_format');
            $('#password').parents('.validate').find('.error').remove();
            $('#password').parents('.validate').find('.mandatory-text').remove();
            $('#password').parents('.validate').append("<p class='mandatory-text'><span>" + error_message + "</span></p><div class='error invalid'></div>");
            self._errorCount(self._errorCount() + 1);
            self._errorInvalidList.push({label:jQuery.i18n.prop('label_new_password'), index: 'password'});
            //$('.password-guide > span').attr("style","color:red");
             self.validatePasswordNewPolicy();
		 } else {
		     $('.validate-bo li').each(function() {
                 $(this).attr("class", "mi-validate-pass");
                 $(this).find('i').attr("class", "icon icon-verification-tick-mark");
             });
         }
		    
		 if (self.password2() == '') {
		      var error_message = jQuery.i18n.prop('message_confirm_password_required');
		      $('#password2').parents('.validate').find('.error').remove();
		      $('#password2').parents('.validate').find('.mandatory-text').remove();
		      $('#password2').parents('.validate').append("<p class='mandatory-text'><span>" + error_message + "</span></p><div class='error required'></div>"); 
		      self._errorCount(self._errorCount() + 1);
		      self._errorRequiredList.push({label:jQuery.i18n.prop('label_confirm_new_password'), index: 'password2'});
		 } else if (self.password1() != self.password2()) {
		      var error_message = jQuery.i18n.prop('message_confirm_password_not_matching');
		      $('#password2').parents('.validate').find('.error').remove();
		      $('#password2').parents('.validate').find('.mandatory-text').remove();
		      $('#password2').parents('.validate').append("<p class='mandatory-text'><span>" + error_message + "</span></p><div class='error invalid'></div>"); 
		      self._errorCount(self._errorCount() + 1);
		      self._errorInvalidList.push({label:jQuery.i18n.prop('label_confirm_new_password'), index: 'password2'});
		      return false;
		 }
		 
		
		  if (self._errorCount() === 0) {
		    $('#login-form').find('.error').remove();
		    $('#login-form').find('.mandatory-text').remove();
		    url = '/application/index/passwordResetRequest';
		    postData = [{name: 'token', value: $('input#token').val()}, {name: 'user', value: self.username()}, {name: 'password', value: self.password1()}, {name: 'password2', value: self.password2()}, {name: 'browserTabId', value: browserTabId}];

		    /* Send the data using post */
		    var posting = $.post(url, postData);
		
		    //Put the results in a div 
		    posting.done(function(data) {
		        //self.reset(formElement);                
		    });
		
		}
        return false;
    };
    self.validatePasswordNewPolicy = function() {
        var hasUpperCase = /[A-Z]/.test(self.password1());
        var hasLowerCase = /[a-z]/.test(self.password1());
        var hasNumbers = /\d/.test(self.password1());
        var hasSpecialCharacters = /[!@#$%^&*()\\_+.]/.test(self.password1());
        if (self.password1().length < 10) {
            $('.validate-bo > #length').attr("class", "mi-validate-error");
            $('.validate-bo > #length > i').attr("class", "icon icon-important");
        } else {
            $('.validate-bo > #length').attr("class", "mi-validate-pass");
            $('.validate-bo > #length > i').attr("class", "icon icon-verification-tick-mark");
        }
        if (!hasUpperCase) {
            $('.validate-bo > #uppercase').attr("class", "mi-validate-error");
            $('.validate-bo > #uppercase > i').attr("class", "icon icon-important");
        } else {
            $('.validate-bo > #uppercase').attr("class", "mi-validate-pass");
            $('.validate-bo > #uppercase > i').attr("class", "icon icon-verification-tick-mark");
        }
        if (!hasLowerCase) {
            $('.validate-bo > #lowercase').attr("class", "mi-validate-error");
            $('.validate-bo > #lowercase > i').attr("class", "icon icon-important");
        } else {
            $('.validate-bo > #lowercase').attr("class", "mi-validate-pass");
            $('.validate-bo > #lowercase > i').attr("class", "icon icon-verification-tick-mark");
        }
        if (!hasNumbers) {
            $('.validate-bo > #number').attr("class", "mi-validate-error");
            $('.validate-bo > #number > i').attr("class", "icon icon-important");
        } else {
            $('.validate-bo > #number').attr("class", "mi-validate-pass");
            $('.validate-bo > #number > i').attr("class", "icon icon-verification-tick-mark");
        }
        if (!hasSpecialCharacters) {
            $('.validate-bo > #special').attr("class", "mi-validate-error");
            $('.validate-bo > #special > i').attr("class", "icon icon-important");
        } else {
            $('.validate-bo > #special').attr("class", "mi-validate-pass");
            $('.validate-bo > #special > i').attr("class", "icon icon-verification-tick-mark");
        }
    };
    self.submitForgetPassword = function(formElement) {
        if($('#response-error').length > 0) {
            $('#response-error').remove(); 
        }
        self._errorCount(0);
        self._errorRequiredList([]);
        self._errorInvalidList([]);
        self._errorRequiredListToggle(false);
        self._errorInvalidListToggle(false);
        $('#login-form').find('.error').remove();
        $('#login-form').find('.mandatory-text').remove();     
        
        if (self.username() === '') {
        	var error_message = jQuery.i18n.prop('label_please_fill_in_this_mandatory_field');
            $('#user').parents('.validate').find('.error').remove();
            $('#user').parents('.validate').find('.mandatory-text').remove();
            $('#user').parents('.validate').append("<p class='mandatory-text'><span>" + error_message + "</span></p><div class='error invalid'></div>"); 
            self._errorCount(self._errorCount() + 1);
            self._errorRequiredList.push({label:jQuery.i18n.prop('label_email'), index: 'user'});
        
        } else if (!self.validateEmail(self.username())) {
               var error_message = jQuery.i18n.prop('message_email_address_entered_is_not_valid');
               $('#user').parents('.validate').find('.error').remove();
               $('#user').parents('.validate').find('.mandatory-text').remove();
               $('#user').parents('.validate').append("<p class='mandatory-text'><span>" + error_message + "</span></p><div class='error invalid'></div>"); 
               self._errorCount(self._errorCount() + 1);
               self._errorInvalidList.push({label:jQuery.i18n.prop('label_email'), index: 'user'});
         }

         if (self._errorCount() === 0) {
            $('#login-form').find('.error').remove();
            $('#login-form').find('.mandatory-text').remove();
            url = '/application/index/check-user-sso-enabled';
            postData = $(formElement).serializeArray();
            postData.push({
                'name' : 'browserTabId',
                'value' : browserTabId
            });
            self.formPostData(postData);
            /* Send the data using post */
            var posting = $.post(url, postData);

            /* Put the results in a div */
            posting.done(function(data) {

            });
        }
        return false;
    };
    self.checkSsoEnabled = function (data) {
        data = jQuery.parseJSON(data.message);
        if (data.loginType && data.loginType === "20250") {
            self.errorLoginSso(true);
            self._errorCount(1);
        } else {
            self.errorLoginSso(false);
            self._errorCount(0);
            url = '/application/index/forget-password-request';
            postData = self.formPostData();
            /* Send the data using post */
            var posting = $.post(url, postData);

            /* Put the results in a div */
            posting.done(function(data) {
                self._submitMessage(true);
                //self.reset(formElement);
            });
        }
    }
}

function baseView(menuItems) {
    var self = this;
    self.menuItems = menuItems;
    self.userId = ko.observable('');
    self.username = ko.observable('');
    self.surname = ko.observable('');
    self.firstName = ko.observable('');
    self.photo = ko.observable('');
    self.roleRights = ko.observableArray([]);
    self.userDataLoaded=$.Deferred();
    self._pageTitle = ko.observable('');
    self.formChange = ko.observable(false);
    self.landingPage = ko.observable('');
    self.calendarView = ko.observable('agendaWeek');
    self.templateTextChange = ko.observable(false);
    self.logout = function(){
    	localStorage.removeItem('visitedLinks');
        location.href = '/?logout=true';
    },
    self.errorAppend = function(crntControl, msg){

        var parent = $(crntControl).parents('.formRow');

        if(msg){
            var parent = $(crntControl).parents('.formRow');
            $(parent).find('.error_message_dev').remove();
            $(crntControl).addClass('controlError');
            if ($(crntControl).closest('.select.orrange')) {
                $(crntControl).closest('.select.orrange').addClass('controlError');
            }

            $(parent).find('.labelContainer').addClass('error-message').append(
                    '<div class="error_message_dev">' + $.trim(msg) + '</div>');
        }

    };

    self.removeError = function(crntControl){
        // First two lines added, while fixing error (Author: M. Mehdi Raza)
        var controlNode = crntControl.nodeName.toLowerCase();
        var controlName = $(crntControl).attr('name');
        // *****************************
        var parent = $(crntControl).parents('.formRow');
        if ($(crntControl).is(':radio') || $(crntControl).is(':checkbox')) {
            $(crntControl).parents('.formRow, td').find(controlNode + '[name=' + controlName + ']')
                    .removeClass('controlError');
            $(parent).find('.labelContainer').removeClass('error-message');
            $(parent).find('.error_message_dev').remove();
        } else if ($(crntControl).is(':text')
                && ($(crntControl).attr('data-mask') == 'date_dropdown'
                        || $(crntControl).attr('data-mask') == 'date_time_dropdown'
                        || $(crntControl).attr('data-mask') == 'month_year_dropdown'
                        || $(crntControl).attr('data-mask') == 'date_time_picker_movein' || $(crntControl)
                        .attr('data-mask') == 'time_dropdown')) {
            parent = $(crntControl).parents('.formRow');
            $(crntControl).parents('.formRow, td').find('select').removeClass('controlError');
            $(parent).find('.labelContainer').removeClass('error-message');

            $(parent).find('.error_message_dev').remove();
        } else {

            parent = $(crntControl).parents('.formRow');
            $(parent).find('.labelContainer').removeClass('error-message');
            $(crntControl).removeClass('controlError');

            if ($(crntControl).closest('.select.orrange')) {
                parent = $(crntControl).parents('.formRow');
                $(crntControl).closest('.select.orrange').removeClass('controlError');
                $(parent).find('.labelContainer').removeClass('error-message');
            }
            $(parent).find('.error_message_dev').remove();
        }
    };

    //Callbacks defered Object list
    self.callBacksDeferred=[];

    self.setMainMenuHref = function(parent) {
        parent.currentHref(parent.name + '/' + this.name);
        //document.title = moveInViewModel.translate(this.name); // no need of page title from here any more.
        return true;
    },
    //show form Title
    self.formHeaderTitle = function(data) {
        var title = '';
        if(data.id == 'duplicate') {
            title = jQuery.i18n.prop('label_new' + data.formName.replace('label_','_').replace('entity_','_'));
        }
        else {
            title = jQuery.i18n.prop(((data.id == 'new') ? 'label_new':'label')+data.formName.replace('label_','_').replace('entity_','_'))+((data.id!='new')?' : '+baseView._pageTitle() :'')
        }
        return title;
    },
        self.sessionLogCallback  = function(data) {
            let dataObject = jQuery.parseJSON(data.message);
            if (dataObject.data.status === 'logout') {
                location.href = '/?logout=true';
            }
        };
    self.updateCurrentUserName = function(data) {
        dataObject = jQuery.parseJSON(data.message);
        //MID-2416: if the logged in user is deleted, logout.
        if (typeof dataObject.data.id === 'object' || dataObject.data.deleted == true) {
            location.href = '/?logout=true';
        }

        self.userId(dataObject.data.id);
        if (typeof dataObject.data.username == 'undefined') {
            self.username(dataObject.data.emailAddress);
        } else {
            self.username(dataObject.data.username);
        }

        self.surname(dataObject.data.surname);
        self.firstName(dataObject.data.firstName);
        self.photo(dataObject.data.photo || '');
        self.landingPage(dataObject.data.landingPage || '');
        self.calendarView(dataObject.data.calendarView || 'agendaWeek');
        if (typeof dataObject.data.role != 'undefined') {
            
            dataObject.data.role = asArray(dataObject.data.role)
            $.each(dataObject.data.role, function(roleIndex, role) {
                role.rights = asArray(role.rights);
                role.scorerRights = asArray(role.scorerRights);
                //revove rights that the instance should not have
                var rightsToRemove = [];
                $.each(role.rights, function(rindex, right) {
                    var found = false;
                    $.each(dataObject.data.packages, function(pindex, packages) {
                        if (right.entity == packages.id) {
                            found = true;
                        }
                    });
                    if(found == false) {
                        rightsToRemove.push(rindex);
                    }
                });

                for (var i = rightsToRemove.length -1; i >= 0; i--) {
                    role.rights.splice(rightsToRemove[i],1);
                }
            });

            self.roleRights(dataObject.data.role)
        }
        
        dataObject.data.packages = asArray(dataObject.data.packages);
        var packages = [];
        dataObject.data.packages.forEach(function(package) {
            packages.push(package.id);
        });
        self.userDataLoaded.resolve();
        if(moveInViewModel) {
            moveInViewModel.currentUser({
                userId: self.userId(),
                username : self.username(),
                firstName: self.firstName(),
                surname: self.surname(),
                photo: self.photo(),
                role: self.roleRights(),
                landingPage: self.landingPage(),
                calendarView: self.calendarView(),
                userQsThemeSelected: (typeof dataObject.data.qsTheme === 'string' && dataObject.data.qsTheme === '1'),
                applicationBrandName: dataObject.data.applicationBrandName
            });
            moveInViewModel.bindDataPromise.then(function() {
                moveInViewModel.permission.init(self.roleRights(), packages);
                moveInViewModel.permission.userRightsLoaded.resolve();
            });
        }
    };

    self.deployTranslations = function(data) {
        data = jQuery.parseJSON(data.message);
        if (Object.prototype.toString.call(data.listData) === '[object Object]') {
            data.listData = new Array(data.listData);
        };
        url = '/translate/translate/deploy';
        /* Send the data using post */
        $.post(url, {
            'translations' : JSON.stringify(data.listData),
            'browserTabId' : browserTabId
        });
    };

    self.downloadTranslations = function(data) {
        data = jQuery.parseJSON(data.message);

        if (Object.prototype.toString.call(data.listData) === '[object Object]') {
            // new Array(data.listData);
            data.listData = new Array(data.listData);
        };

        var xmlDocument = $.parseXML("<localization/>");

        laguages = ['Eng', 'Fra', 'Deu', 'Esp', 'Ita', 'Inl'];

        $.each(data.listData, function(index, value) {
            keyNode = xmlDocument.createElement('key');
            keyNode.setAttribute('name', value.key);
            xmlDocument.documentElement.appendChild(keyNode);

            $.each(laguages, function(li, lv) {

                currentLang = 'value' + lv;
                if (value[currentLang]
                && !jQuery.isEmptyObject(value[currentLang])) {

                    valueNode = xmlDocument.createElement('value');

                    valueNode.appendChild(xmlDocument
                            .createTextNode(value[currentLang]));
                    valueNode.setAttribute('lang', lv);
                    keyNode.appendChild(valueNode);

                }

            });

        });

        xmlDocument = (new XMLSerializer()).serializeToString(xmlDocument);
        xmlString = '<?xml version="1.0"  encoding="UTF-8"?>' + xmlDocument;

        form = $('<form action="/translate/translate/download2" method="post" target="_blank">');
        form.append($('<input type="hidden" name="xml" id="xml"> ').attr(
                'value', xmlString));
        form.appendTo('body').submit();

    };

    self.genericDialog = function(data) {
        data = jQuery.parseJSON(data.message);
        if (data.showMessage!="false"){
            var text = '';
            var title = '';

            if (data.text != '' && !$.isEmptyObject(data.text)) {
                text = jQuery.i18n.prop(data.text);
            }

            if (data.title != '' && !$.isEmptyObject(data.title)) {
                title = jQuery.i18n.prop(data.title);
            }

            $("#dialog-modal").html(text);
            $("#dialog-modal").dialog({
                height : 'auto',
                modal : true,
                title : title,
                buttons : [{
                    text : jQuery.i18n.prop("button_ok"),
                    click : function() {
                        $(this).dialog("close");
                        $("#dialog-modal").html('');
                        $(this).dialog("destroy");
                    }
                }]
            });
        }
    };

    self.CheckLeadDependency = function(data){
        data = jQuery.parseJSON(data.message);
        controlObj = $('[callbackId="' + data.callBackId + '"]');
        if(data.message=='confirmDelete'){
           controlObj.removeAttr('disabled callbackId');
        } else {
           controlObj.attr('disabled', 'disable');
        }
    };
    /**
     * Check dependency  to check whether to allow radio button to change value
     */
    self.CheckRadioDependency = function(data){
        data = jQuery.parseJSON(data.message);
        controlObj = $('[callbackId="' + data.callBackId + '"]');
        if(data.message=='confirmDelete'){
        } else {
           controlObj.prop( "checked", true );
        }
    };

    self.dependancyFaultCheckOnEmbeddedDocument=function(data){
        data = jQuery.parseJSON(data.message);
        $("#dialog-modal").html(
                '<div class="dailog-ui-confirm-delete-div"><div class="delete-icon"></div>'+jQuery.i18n.prop("message_delete_item_failed") + '</div>'
                +'<div style=""><ul><li>'+jQuery.i18n.prop('entity_' + data.entityNameKey.faultDatails) +'</li></ul></div>');
        $("#dialog-modal").dialog({
            height : 'auto',
            modal : true,
            title : jQuery.i18n.prop(data.message.toLowerCase()),
            buttons : [ {
                text : jQuery.i18n.prop("button_ok"),
                click : function() {
                    $(this).dialog("close");
                    $("#dialog-modal").html('');
                    $(this).dialog("destroy");
                }
            } ]
        });
    };

    self.dependancyFaultCheckOnEmbeddedDocumentNotFound=function(data){
        data = jQuery.parseJSON(data.message);
        var fieldset=$('fieldSet[windowId="'+data.windowId+'"]');
        var targetContainer = fieldset.parents('div[allow_plus_minus=true]');

        fieldset.find('.formRow').not('.hiddenRow').remove();
        fieldset.find('.plainText').remove();
        fieldset.find('.remove').remove();
        fieldset.attr('delete','true');
        fieldset.siblings('.addSection').fadeIn('fast');
        //fieldset.unbind().remove();
        resetCounts(targetContainer);
        if (fieldset.find('.formRow.hiddenRow input').val()==""){
            fieldset.remove();
        } else {
            fieldset.hide();
        }
    };
    self.teste = '';
    /**
     * check duplicate Record And Validate
     * @author : Usman Shah
     */
    self.checkDuplicate = function(data) {
        var message = jQuery.parseJSON(data.message);
        if(message.data.field.duplicateCheck=='checkMultiDuplicate'){
            self.checkMultiDuplicate(message);
            return false;
        }

        // The active page/form should be validate with the below done code, instead of $('form')
        // Fix By, Mudassar Mumtaz
        var form =  $(pager.activePage$().element).find('form');
        var crntFormBuilder = form.data('formBuilder');
        var currentControl = $(form).find('#' + message.inputId);
        var docId = crntFormBuilder.formObj.find("input[name="+message.labelId+"]").val();
        //check if new Record
        if(docId == '') {
            if(!$.isEmptyObject(message.data.field.duplicateCheck)) {
                result = {result:false, msg:jQuery.i18n.prop(message.message)};
                crntFormBuilder.validate(currentControl, 'normal', result);
            }else{
                result = {result:true, msg:""};
                crntFormBuilder.validate(currentControl, 'normal', result);
            }
        }else{
            if(!$.isEmptyObject(message.data.field.duplicateCheck) && (message.data.field.duplicateId != docId)) {
                result = {result:false, msg:jQuery.i18n.prop(message.message)};
                crntFormBuilder.validate(currentControl, 'normal', result);
            }else{
                result = {result:true, msg:""};
                crntFormBuilder.validate(currentControl, 'normal', result);
            }
        }
        
        // remove current control validating duplicate class if exists
        $(currentControl).removeClass('validating-duplicate');
        
        // check if Submit clicked then save form
        var submitClicked = $(form).find('.submit-clicked');
        
        if(submitClicked.length > 0){
            $(submitClicked).removeClass('submit-clicked');
            var saveButton = $(form).find('button[name="button_save"]');
            saveButton.trigger('click');
        }
    };

    /**
     * check duplicate Record on multiple fields
     * and validate them
     * @author : Mudassar Mumtaz
     */
    self.checkMultiDuplicate = function(data) {
        var form =  $(pager.activePage$().element).find('form');
        var crntFormBuilder = form.data('formBuilder');
        var docId = crntFormBuilder.formObj.find("input[name="+data.labelId+"]").val();
        if(docId == '') {
            result =  (!$.isEmptyObject(data.data.field.duplicateId) && parseInt(data.data.field.duplicateId)!=0) ? {result:false, msg:jQuery.i18n.prop(data.message)} : {result:true, msg:""};
        } else {
            result = (!$.isEmptyObject(data.data.field.duplicateId) && (data.data.field.duplicateId != docId) && parseInt(data.data.field.duplicateId)!=0) ?
                    result = {result:false, msg:jQuery.i18n.prop(data.message)} : {result:true, msg:""};
        }

        for(var key in data.inputId){
            var currentControl = crntFormBuilder.formObj.find('[name="' + data.inputId[key] +'"]');
            crntFormBuilder.validate(currentControl, 'normal', result);
            // remove current control validating duplicate class if exists
            $(currentControl).removeClass('validating-duplicate');
        }
        
        // check if Submit clicked then save form
        var submitClicked = $(form).find('.submit-clicked');
        
        if(submitClicked.length > 0){
            $(submitClicked).removeClass('submit-clicked');
            var saveButton = $(form).find('button[name="button_save"]');
            saveButton.trigger('click');
        }
    };

    // dependecy faults
    self.dependancyFault = function(data) {
        data = jQuery.parseJSON(data.message);
        grid = self.grids[data.windowId].grid;
        if (data.type == 'section') {
            grid.dependencySectionBox(data);
        }else {
            grid.dependencyBox(data);
        }
    };
    // confirm box for grids
    self.confirm = function(data) {
        data = jQuery.parseJSON(data.message);
        grid = self.grids[data.windowId].grid;
        grid.confirmBox(data);
    };

    // confirm Section box for grids
    self.confirmSection = function(data) {
        data = jQuery.parseJSON(data.message);
        grid = self.grids[data.windowId].grid;
        grid.confirmSectionBox(data);
    };
    // delete grid row
    self.deleteGridRow = function(data) {
        data = jQuery.parseJSON(data.message);
        grid = self.grids[data.windowId].grid.search();
        // grid.deleteGridRow(data);
    };
    /**
     * delete grid section for CustomList Grid
     * @author Mudassar Ali
     */
    self.deleteGridSection = function(data) {
        data = jQuery.parseJSON(data.message);
        var tempSections = self.grids[data.windowId].grid.sections();
        self.grids[data.windowId].grid.sections([]);
        $.each(tempSections, function (index, item) {
            if (item.id != data.id) {
                self.grids[data.windowId].grid.sections.push(item);
            }
        });
        grid = self.grids[data.windowId].grid.search();
    };

    self.processMessage = function(message) {
        switch (message.message) {
        case 'dependancyFault' :
            html = $('<div>').append(
                    $('<div>').text(
                            jQuery.i18n.prop('fault_'
                                    + message.message.toLowerCase()))
            ).append(
                    $('<div>').append(
                            $('<ul><li>').text(
                                    jQuery.i18n.prop('entity_document_'
                                            + message.faultDatails
                                            .toLowerCase()))));
            message = {
                    'message' : html
            };
            break;
        default :
            message = {
                'message' : 'unknowError'
        };
        }
        return message;
    };
    // single page view
    self.singlePageView = function(data) {
        var data = jQuery.parseJSON(data.message);
        var binding = ko.contextFor($('#' + data.windowId).get(0));
        var $data = binding.$data;
        var currentFormObject = $(pager.activePage$().element).find('form');
        $data.formData = data.tabData;
        $data.formActive(true);
        // tabname and titlename work.
        if(typeof data.tabData.formData.data.name != 'undefined') {
            self._pageTitle(data.tabData.formData.data.name);
        }
        else if(typeof data.tabData.formData.data.firstName != 'undefined') {
            self._pageTitle(data.tabData.formData.data.firstName);
        }
        else if(typeof data.tabData.formData.data.formName != 'undefined') {
            self._pageTitle(data.tabData.formData.data.formName);
        }
        else if(typeof data.tabData.formData.data.key != 'undefined') {
            self._pageTitle(data.tabData.formData.data.key);
        }
        getPageTileForEntity($data, true);

        if(data.tabData.formXml == 'templates/applicationConfig/forms/edit.xml') {
            moveInViewModel.setPageTitle(jQuery.i18n.prop('entity_general_setting').toUpperCase());
        }
        // end tabname and title name
    };

    self.personView = function(data) {
        var data = jQuery.parseJSON(data.message);
        var binding = ko.contextFor($('#' + data.windowId).get(0));
        var $data = binding.$data;
        $data.formData = data.tabData;


        $data.formActive(true);
    };

    self.personPageView = function(data) {
        data = jQuery.parseJSON(data.message);
        binding = ko.contextFor($('#' + data.windowId).get(0));
        bindingData = binding.$data;

        // get the lead souce main area
        leadSource = jQuery.grep(bindingData.personView.mainPersonArea(),
                function(a) {
            return a.title == 'entity_lead_source';
        });

        leadSource = leadSource[0];

        // add all lead sources that dont already exist in the view

        // add new items onto the front of the array
        data.personData.lead = asArray(data.personData.lead);
        $.each(data.personData.lead, function(i, v) {
            itemExists = jQuery.grep(leadSource.items(), function(a) {
                return a.id == v.id;
            });
            if (itemExists.length== 0) {
                lead = new mainPersonAreaItem(v);
                leadSource.items.unshift(lead);
            }
        });

        //navigate to first page if no pages currently selected
        if (binding.$page.route.length ==2 && leadSource.items().length > 0) {
            pager.navigate('#'+ binding.$page.getFullRoute()().join('/')+'/'+data.personData.id+'/entity_lead_source/'+leadSource.items()[0].id);
        }
    };

    // close a single page view and navigate to main page
    self.closeSingleView = function(data) {
        data = jQuery.parseJSON(data.message);
        //page = ko.contextFor($('#' + data.windowId).get(0));
        var urlParentId = pager.page.route[1];
        if($('#' + urlParentId + ' #' + moveInViewModel.windowId()).length > 0) {
            page = ko.contextFor($('#' + urlParentId + ' #' + moveInViewModel.windowId()).get(0));
        } else {
            page = ko.contextFor($('#' + data.windowId).get(0));
        }
        parentPage = page.$page.viewModel.name;
        mainPage = page.$page.parentPage.ctx.name;
        pager.navigate('#' + mainPage + '/' + parentPage);

        $.each(self.menuItems, function(i, v) {
            $.each(v.submenuItems, function(smi, smv) {
                smv.singlePageViews.remove(function(item) {
                    return item.pageId == data.windowId;
                });
            });
        });
    };

    /**
     * This function generates complete page path from current to parent
     * @author Mudassar Ali
     */
    self.getParentPath = function(page,detailPage) {
        var path = "", lastnode= "";
        for (index in page.$parents) {
            var node = page.$parents[index];

            // Parents have repeated pages so dont include them in path, also dont include undefined and first parent in path
            if (lastnode == node.name || index == 0 || node.name == undefined || node.name == 'undefined') {
                continue;
            }
            path = node.name + "/" + path;
            lastnode = node.name;
        }

        if (detailPage) {
            path = path.replace(lastnode, '#' + lastnode + '_view');
            if(path == '#form-admin_view/label_portal/'){
                path = '#form_admin_view/label_portal/';
            }
            if(path == '#programme-admin_view/entity_intake/'){
                path = '#programme_admin_view/entity_intake/';
            }
            if(path == '#programme-admin_view/entity_program_type/'){
                path = '#programme_admin_view/entity_program_type/';
            }
            if(path == '#programme-admin_view/entity_program/'){
                path = '#programme_admin_view/entity_program/';
            }
        } else {
            path = path.replace(lastnode, '#' + lastnode)
        }
        return path;
    }

    self.singleViewMessage = function(data) {
        oldData = data;
        data = jQuery.parseJSON(data.message);
        //page = ko.contextFor($('#' + data.windowId).get(0));

        var urlParentId = pager.page.route[1];
        if($('#' + urlParentId + ' #' + moveInViewModel.windowId()).length > 0) {
            page = ko.contextFor($('#' + urlParentId + ' #' + moveInViewModel.windowId()).get(0));
             if (typeof page.$data.afterSave != "undefined") {
                var redirectUrl = page.$data.afterSave(oldData);
                if (redirectUrl) {
                   pager.navigate('#'+redirectUrl) ;
                   return;
                }
             }
        } else {
             page = ko.contextFor($('#' + data.windowId).get(0));
        }


        // if new record is added then redirect to grid view.
        page.$data.submitMessage(true);
        page.$data.submitMessageText(jQuery.i18n.prop(data.message));
        self.formChange(false);// disable form edit observable
        if (page.$data.id == 'new' || page.$data.id == 'duplicate') {
            messageTimeout=1000;
            messageRemoveTimeout=10000;
            page.$data.formActive(true);
            //Manage navigation of lead/opportunity on save
            if (page.$page.viewModel.name == "entity_opportunity" || page.$page.viewModel.name == "entity_leads") {
                var path = '';
                if (page.$page.viewModel.name == "entity_leads") {
                    path = '#person-details/'+data.rowId+'/leadsource/'+data.newDoc['MoveIn4Person-Document-LeadDocument'];
                } else if (page.$page.viewModel.name == "entity_opportunity") {
                    path = '#person-details/'+data.rowId+'/opportunity/'+data.newDoc['MoveIn4Person-Document-OpportunityDocument'];
                }
                pager.navigate(path);
                return;
            }

            parentPage = page.$page.viewModel.name;
            mainPage = page.$page.parentPage.ctx.name;

            if (!page.$data.id == 'duplicate' || !page.$page.viewModel.name == 'entity_form_types') { // avoid breaking chrome on entity_form_types page
                // /Close new Record view
                self.closeSingleView(oldData);
            }
            else if(page.$data.id == 'new') { // old data exist if new record is created and then click on create new. form should close after save. MID-2330
                self.closeSingleView(oldData);
            }

            // Redirect to edit page for edit
           var parentPath=self.getParentPath(page , true);

            if(parentPath=="#form-admin_view/entity_forms/"){
                parentPath="#form_admin_view/entity_forms/"
            } else if(parentPath == '#programme-admin/programme-type-form/_view/') {
                parentPath = parentPath.replace('_view/', '');
            }

            var viewModelNames = [
                                  'programme-admin/programme-type-form',
                                  'programme-admin/programme-form',
                                  'programme-admin/intake-form',
                                  'form-admin/portal-form',
                                  'form-admin/contact-manager-portal-form',
                                  'form-admin/forms-form',
                                  'system-admin/custom-list-form',
                                  'system-admin/custom-attribute-form',
                                  'system-admin/marketing-source-form',
                                  'system-admin/email-config-form',
                                  'system-admin/email-template-form',
                                  'system-admin/general-setting/form',
                                  'system-admin/email-template-form',
                                  'system-admin/his-export-form',
                                  'system-admin/document-repository-form',
                                  'system-admin/document-templates-form',
                                  'system-admin/users-form',
                                  'system-admin/scoring-admin/scoring-form-type-form',
                                  'reputation-admin/subject-area-form'


              ];

            if ($.inArray(page.$page.viewModel.name , viewModelNames) >= 0) {
                parentPath = page.$page.viewModel.name+'/';
            }

            pager.navigate(parentPath + data.rowId+'/');

            setTimeout(function() {
                var newpagecontext;
                // The actual page is get from find more robust as it is now making use of updating value of data.rowId instead of old
                var ctpage = pager.page.find(parentPath.replace("#",'') + data.rowId);
                newpagecontext = ctpage.bindingContext.$data;
                newpagecontext.submitMessage(true);
                newpagecontext.submitMessageText(jQuery.i18n.prop(data.message));
            }, messageTimeout);
            setTimeout(function() {
                var newpagecontext;
                var ctpage = pager.page.find(parentPath.replace("#",'') + data.rowId);
                newpagecontext = ctpage.bindingContext.$data;
                newpagecontext.submitMessage(false);
                // empty submitMessageText when hidding.
                newpagecontext.submitMessageText('');
            }, messageRemoveTimeout);
        } else {
            //FIXME: Find a better approach like bindable way of link images
            // Check if form has user img and
            if (pager.page.route[1] == 'users-form') {

                var fileId = '';
                    
                if(data.data.croppedProfilePic && !$.isEmptyObject(data.data.croppedProfilePic.fileStorageId)) {
                    fileId = data.data.croppedProfilePic.fileStorageId;
                }
                    
                var fileUrl = '/theme/images/user.png';
                    
                if (fileId != '') {
                    fileUrl = '/formConfig/formConfig/files?&operation=view&fileId='+fileId+'?timestamp=' + new Date().getTime();
                    moveInViewModel.systemAdmin.usersForm.userPicFileId(fileId);
                    //$('.profile-user img').attr('src', fileUrl);
                } 
                
                if ( data.rowId == baseView.userId()) {
                    $('.userIcon img').attr('src', fileUrl);
                }
            
            }

            if(data.newDoc){
                var newFieldsets = '';
                for (first in data.newDoc) {
                    newFieldsets = data.newDoc[first];
                    break;
                }
                // Assign the Ids to New Instances Fieldsets. Generic function work on all forms.
                // @author mudassar mtz
                if($(document).find("input[value='"+data.data.id+"']")){
                    var counter = 0;
                    $("input[value='"+data.data.id+"']").closest('form').find('fieldset[namex!="croppedProfilePic"]').each(function(){

                        if($(this).find('.hiddenRow input') && $(this).find('.hiddenRow input').val()==''){
                            if(typeof newFieldsets == 'string'){
                                $(this).find('.hiddenRow input').val(newFieldsets);
                            } else {
                                $(this).find('.hiddenRow input').val(newFieldsets[counter]);
                                counter++;
                            }
                        }
                    });
                }
            }

            //change tabname and title name after save.
            if(typeof page.$page.viewModel.titleName != 'undefined') {
                //self._pageTitle(page.$page.viewModel.titleName());
                //moveInViewModel.setPageTitle(page.$page.viewModel.titleName());
            } else if(typeof data.data.name != 'undefined') {
                self._pageTitle(data.data.name);
                moveInViewModel.setPageTitle(createFormTitle(page.$data), data.data.name);
            }
            else if(typeof data.data.firstName != 'undefined') {
                self._pageTitle(data.data.firstName);
                moveInViewModel.setPageTitle(createFormTitle(page.$data), data.data.firstName);
            }
            else if(typeof data.data.key != 'undefined') {
                self._pageTitle(data.data.key);
                moveInViewModel.setPageTitle(createFormTitle(page.$data), data.data.key);
            }
            //End of change tabname and save tab name after save.
            setTimeout(function() {
                page.$data.submitMessage(false);
                page.$data.submitMessageText('');
            }, 5000);
        }
        
        //remove any submitting class from submit button
        setTimeout(function() {
            $('.submitting').removeClass('submitting');
        }, 1500);
    };

    // insert new values in fancy drop down
    self.updatefancySelect = function(data){

        if (data.message) {
            data = jQuery.parseJSON(data.message);
            if (!data.listData) {
                data.listData = new Array();
            }
            data.listData = asArray(data.listData);
        }
        
        data.listData.sort(function(a, b) {
            if (!a[data.value] || Object.prototype.toString.call(a[data.value]) === '[object Object]') {
                var nameA = '';
            } else {
                var nameA = (a[data.value] || '').toLowerCase()
            }

            if (!b[data.value] || Object.prototype.toString.call(b[data.value]) === '[object Object]') {
                var nameB = '';
            } else {
                var nameB = (b[data.value] || '').toLowerCase()
            }

            if (nameA < nameB) // sort string ascending
                return -1;
            if (nameA > nameB)
                return 1;
            return 0; // default return value (no sorting)
        });

        option = ''; //$("<option></option>").attr("value", '').text(' ' + moveInViewModel.translate('label_please_select'));
        var popupOption = ''; //$("<option></option>").attr("value", '').text(' ' + moveInViewModel.translate('label_please_select'));
        var controlObj = $('[callbackId="' + data.id + '"]');
        var currentIdObj = $(controlObj).attr('id');
        //check for status if empty reason then hide status reason hiddenRow
        var rowControl = $(controlObj).closest('.formRow');
        if(data.control == 'status') {
            Object.keys(data.listData[0]).length == 0 ? $(rowControl).hide() : $(rowControl).show(); $(rowControl).removeClass('hiddenRow'); $(rowControl).find('.hiddenRow').removeClass('hiddenRow');$(rowControl).find('.labelContainer').show();
        }
        // uservals = false;
        uservals = new Array();
        if ($(controlObj).data('uservals')) {
            uservals = asArray($(controlObj).data('uservals'));
        }
        $.each(data.listData, function(index, value) {
            option = $("<option></option>").attr("value", value[data.key]).text(value[data.value]);
            if(uservals.length) {
                if(uservals.indexOf(value[data.key]) !== -1) {
                    $(option).attr('selected', true);
                }
            }
            if(index==0){
                controlObj.html('');
                var defaultOption = $("<option value=''>" + ' ' + moveInViewModel.translate('label_please_select') + "</option>");

                //controlObj.append(defaultOption);
            }
            controlObj.append(option);
        });
        var targetElmnt = controlObj.parents('form').find('select[callbackId="'+data.id+'"]');
        dodropdown(controlObj.parents('form'), targetElmnt);
        controlObj.removeAttr('callbackId callbackid');
    };

    // update suggest widget options
    // @author: Mudassar Mumtaz
    self.updateSuggestWidget = function(data) {
        if (data.message) {
            data = jQuery.parseJSON(data.message);
            if (!data.listData) {
                data.listData = new Array();
            }
            data.listData = asArray(data.listData);
        }
        var _suggestPersons = [], controlObj = $('[callbackId="' + data.id + '"]');
        data.listData.sort(function(a, b) {
            if (!a[data.value] || Object.prototype.toString.call(a[data.value]) === '[object Object]') {
                var nameA = '';
            } else {
                var nameA = (a[data.value] || '').toLowerCase()
            }

            if (!b[data.value] || Object.prototype.toString.call(b[data.value]) === '[object Object]') {
                var nameB = '';
            } else {
                var nameB = (b[data.value] || '').toLowerCase()
            }

            if (nameA < nameB) // sort string ascending
                return -1;
            if (nameA > nameB)
                return 1;
            return 0; // default return value (no sorting)
        });

        if(controlObj.attr('name')=='label_recipient_person' && (controlObj.closest('form').attr('name')=='label_new_template_form' || controlObj.closest('form').attr('name')=='label_new_email_form')){
            var areaId = controlObj.closest('form').find("select[name=label_area]").val();
            jQuery.each(data.listData, function(index, value) {
                // For Marketing Sources
                var Arr = data.returnField.split('.'), temp=value[Arr[0]];
                for (i=1;i<Arr.length;i++)
                    temp=temp[Arr[i]];

                // Formating the Data and pushing into object then array,
                // require for recipient suggestions in Template Document Activity Form.
                value.lead = ($.isArray(value.lead)) ? value.lead : [value.lead] ;
                value.opportunity = ($.isArray(value.opportunity)) ? value.opportunity: [value.opportunity] ;
                value.application = ($.isArray(value.application)) ? value.application : [value.application] ;

                window.myLead = value.lead;
                if (typeof value.lead[0] != "undefined" || typeof value.opportunity[0] != "undefined" || typeof value.application[0] != "undefined") {
                    var _leadArr = value.lead;

                    value.lead = ($.isArray(_leadArr)) ? _leadArr : [_leadArr] ;
                    var generalData = '';
                     if ( areaId == 9682 ) {
                         // for leads
                         generalData = value.lead;
                     } else if ( areaId == 7949 ) {
                        //for opportunity
                         generalData = value.opportunity;
                     } else if ( areaId == 9683 ) {
                        // for applications
                        generalData = value.application;
                     }

                     generalData = ($.isArray(generalData)) ? ( generalData.length > 0 ) ? generalData : [] : [generalData] ;
                     if ( generalData.length > 0 && generalData[0] != undefined ) {
                         generalData.forEach(function(singleLead){
                                var _marketSource = '', _hasMarketSources = 0;
                                _person={};
                                _person.data = value;
                                _person.id = temp;
                                _person.userRef = value.id;
                                _person.leadRef = singleLead.id;
                                _person.secondaryLeadSource = '';
                                _person.sourceDetail = '';
                                _person.firstName = (value.firstName.length > 0 ? value.firstName : '-') ;
                                _person.surname = (value.surname.length > 0 ? value.surname : '-');
                                _person.applicationName = singleLead.name;
                                _person.opportunityName = singleLead.name;

                                if ( areaId == 9682 ) {
                                    if (typeof singleLead.secondaryLeadSource != undefined && !$.isEmptyObject(singleLead.secondaryLeadSource)) {
                                        _marketSource +=  singleLead.secondaryLeadSource+', ';
                                        _person.secondaryLeadSource = singleLead.secondaryLeadSource;
                                        _hasMarketSources++;
                                    }
                                    if (typeof singleLead.sourceDetail != undefined && !$.isEmptyObject(singleLead.sourceDetail)) {
                                        _marketSource +=  singleLead.sourceDetail;
                                        _person.sourceDetail = singleLead.sourceDetail;
                                        _hasMarketSources++;
                                    }
                                    _marketSource = (_hasMarketSources==1 || _hasMarketSources==0) ? _marketSource.replace(',', '') : _marketSource;
                                } else if ( areaId == 7949 ||  areaId == 9683 ) {
                                    _marketSource = singleLead.name;
                                }

                                var recipientLabel = (_marketSource!='') ? value.firstName +', '+ value.surname + ' - ' + _marketSource : value.firstName+', '+value.surname;

                                _person.label = recipientLabel;
                                _person.value = recipientLabel;
                                _suggestPersons.push( _person );
                            });
                     }
                }

            });
        } else {
            jQuery.each(data.listData, function(index, value) {
                var Arr = data.returnField.split('.');
                // Getting Preffered Email in the returned email array
                var email = ($.isArray(value[Arr[0]])) ? value[Arr[0]] : [value[Arr[0]]];
                var personEmail = '';
                email.forEach(function(record, index) {
                    if (record.preferred==1) {
                        email = record.email;
                        dataEmail = {};
                        dataEmail.email = email;
                        value.email = dataEmail;
                    }
                });

                // Formating the Data and pushing into object then array, require for suggestions.
                _person = {};
                _person.data = value;
                _person.id = email;
                _person.label = value.firstName+' '+value.surname+'   '+email;
                _person.value = value.firstName+' '+value.surname+'   '+email;
                _person.userRef = value.id; // Lead ID
                _suggestPersons.push( _person );
            });
        }

        baseView.callBacksDeferred[data.id].resolve(_suggestPersons);
        $('[callbackId="' + data.id + '"]').removeAttr('callbackId');
    };

    // update a select field on a custom form
    self.updateFormSelect = function(data) {
        if (data.message) {
            data = jQuery.parseJSON(data.message);
            if (!data.listData) {
                data.listData = new Array();
            }
            data.listData = asArray(data.listData);
        }
        var option = $("<option></option>");//.attr("value", '');//.text(' ' + moveInViewModel.translate('label_please_select'));
        var popupOption = ''; //$("<option></option>").attr("value", '').text(' ' + moveInViewModel.translate('label_please_select'));

        var controlObj = $('[callbackId="' + data.id + '"]');
        var currentIdObj = $(controlObj).attr('id');
        $(controlObj).empty();
        controlObj.append(option);

        /*
         * Sorting needs to stop at few drop downs
         * introduce/develop new attribute and parse in form "sort='false'"
         * if not attribute define or define to true sorting occur, no sorting perform on sort="false"
         * @author mudassar mumtaz
         */
        var allowSort = $(controlObj).attr('sort');
        if(allowSort == undefined || allowSort==true){
            data.listData.sort(function(a, b) {
                if (!a[data.value] || Object.prototype.toString.call(a[data.value]) === '[object Object]') {
                    var nameA = '';
                } else {
                    var nameA = (a[data.value] || '').toLowerCase()
                }

                if (!b[data.value] || Object.prototype.toString.call(b[data.value]) === '[object Object]') {
                    var nameB = '';
                } else {
                    var nameB = (b[data.value] || '').toLowerCase()
                }

                if (nameA < nameB) // sort string ascending
                    return -1;
                if (nameA > nameB)
                    return 1;
                return 0; // default return value (no sorting)
            });
        }

        var popupOption = $("<option></option>").attr("value", '').text(moveInViewModel.translate('label_please_select'));
        var controlObj = $('[callbackId="' + data.id + '"]');
        var currentIdObj = $(controlObj).attr('id');
        var is_select = 0;
        //controlObj.append(option);
        //check for status if empty reason then hide status reason hiddenRow
        var rowControl = $(controlObj).closest('.formRow');
        if( data.control == 'status') {
            if( $.isEmptyObject(data.listData) )
            {
                $(rowControl).hide();
                $(rowControl).find('select').removeAttr('data-validation');
                $(rowControl).find('select').attr('disable_validation', 'true');
            } else {
                $(rowControl).show(); $(rowControl).removeClass('hiddenRow');
                $(rowControl).find('.hiddenRow').removeClass('hiddenRow');
                $(rowControl).find('.labelContainer').show();
                $(rowControl).find('select').attr('data-validation', '<validation>\
                                                            <validate type="not_empty"></validate>\
                                                        </validation>');
                $(rowControl).find('.select').next().remove();
            }
            $(rowControl).find('.controlError').removeClass('controlError');
            $(rowControl).find('.error_message_dev').removeClass('error_message_dev');
            // Doing a sorting on orders of status_label_reason
            data.listData.sort(function(a,b) {
                a = a.order;
                b = b.order;
                return a < b ? -1 : (a > b ? 1 : 0);
            });
        }

        // uservals = false;
        uservals = new Array();
        if ($(controlObj).data('uservals')) {
            uservals = asArray($(controlObj).data('uservals'));
        }

        $.each(data.listData, function(index, value) {
            // Check whether it is default selected
            //if (makeDefaultValueForSelectBox(value[data.key])){
            //option = $("<option selected></option>").attr("value", value[data.key]).text(value[data.value]);
            //}else{
            var keys = Object.keys( value );

            if($(controlObj).attr("name") == 'label_template') {
                option = $("<option></option>").attr("value", value['id']).text(value[data.value]);
            } else if($(controlObj).attr("name") == 'label_owner') {
                option = $("<option></option>").attr("value", value['id']).text(value[data.value]+' '+value['surname']);
            } else {
                option = $("<option></option>").attr("value", value[data.key]).text(value[data.value]);
            }
            //add the extra attributes
            if(keys.length>2){
                for(var i=2; i<=keys.length; i++){
                    if($(controlObj).attr("name") == 'label_template') {
                        option.attr("data-message", value['message']);
                    } else {
                        option.attr("data-"+keys[2], value[keys[2]]);
                    }
                }

            }

            if(uservals.length) {
                if(uservals.indexOf(value[data.key]) !== -1) {
                    //$(option).attr('selected', true);
                }
            }
//            else if (value[data.value]=='Open' || value[data.value]=='open'){
//                $(option).attr('selected', true);
//                is_select = 1;
//            }
            controlObj.append(option);
        });

        controlObj.removeAttr('callbackId');
        controlObj.attr('deferredId',data.id);

        var href = controlObj.parents('.formRow').next('.create-new-button').attr('href');
        var elementsArray = [
                                 'entity_program_type',
                                 'entity_program',
                                 'label_referee_form',
                                 'label_forms',
                                 'entity_forms',
                                 'label_password_reset_template',
                                 'label_system_marketing_source',
                                 'label_custom_list',
                                 'label_system_email_account',
                                 'label_milestones_stages'
                             ];
        if( $.inArray( controlObj.attr('name') , elementsArray) >= 0 ){
            var href = controlObj.parents('.formRow').next('.create-new-button').attr('href');
            if(controlObj.parents('.formRow').next('.create-new-button').attr("label_form_type") == "1") {
                 var $label_form_type_id = controlObj.closest("form").find("input[name=label_refree_form_type_id]").find("option:last").attr("value");
//                href = href.replace("label_form_type=" , "label_form_type="+ $label_form_type_id);
                controlObj.parents('.formRow').next('.create-new-button').attr("label_form_type", $label_form_type_id );
            }

            controlObj.parents('.formRow').next('.create-new-button').attr("elementId", controlObj.attr('deferredId') );
            var newButton = controlObj.parents('.formRow').next('.create-new-button');
            var newNote = newButton.next('.note');

            var btn = '';
            if(! controlObj.parents('.formRow').next('.create-new-button').attr("elementId")){
                btn = controlObj.parents('.formRow').find('.create-new-button').attr("elementId", data.id );
            }

            //controlObj.parents('.formRow').next('.create-new-button').attr('href', href.replace("elementId%3D" , "elementId%3D" +controlObj.attr('deferredId')));
            controlObj.parents('.formRow').addClass('before-new-btn');
            controlObj.parents('.formRow').append(newButton);
            controlObj.parents('.formRow').append(newNote);
       }

        var urlParentId = pager.page.route[1];
        if( controlObj.attr('name') == 'label_form_type' && urlParentId == 'forms-form' ) {
            formPage = ko.contextFor($('#' + urlParentId + ' #' + moveInViewModel.windowId()).get(0));
            var defaultValue = (typeof formPage.$page.viewModel.label_form_type() != undefined)?formPage.$page.viewModel.label_form_type():'';
            if( defaultValue != "" ) {
               controlObj.val(defaultValue);
              controlObj.next("ul").find("li[rel="+defaultValue+"]").trigger("click");
            }
        }

        if( controlObj.attr('name') == 'label_list_type'){
            
            var params = pager.page.route[2]; // getting the parameters passed from parent
            
            if ( /listId=([^&]+)/.exec(params) != null ) {
                
                var listId = /listId=([^&]+)/.exec(params)[1]; // Fetch listId
                var listIdValue = listId ? listId : 0;
                
                controlObj.val(listIdValue);
                controlObj.next("ul").find("li[rel="+listIdValue+"]").trigger("click");
                $("select[name='label_list_type']").parent('.select').css('pointer-events', 'none');
                
            }
        }


        // ---- checking and updating template in case of multiple section
        var setContainer = controlObj.parents('.setContainer');
        if (setContainer.length > 0 && setContainer.data('templateid')) {
            var templateId = setContainer.data('templateid');

            // ------- contructing template slug and updating dropdown template
            var templateSlug = $(templatesLog[templateId]);
            var controlSelector = 'select[name="' + controlObj.attr('name')+ '"]';
            templateSlug.find(controlSelector).replaceWith(
                    controlObj.clone(true));
            templatesLog[templateId] = templateSlug.clone().wrap('<div>').parent().html();
        }
        //Resolved this callback
        baseView.callBacksDeferred[data.id].resolve();
        
            if(typeof moveInViewModel.activityForm != 'undefined' && moveInViewModel.activityForm.formId() == 'new' && (controlObj.closest('form').attr('name') =='label_new_template_form' || controlObj.closest('form').attr('name') == 'label_new_email_form')){
                if (controlObj.attr('name') == "label_area") {
                      pager.start();
                      var defaultAreaId = 9681;
                      if(pager.page.route[0] == 'leads' || pager.page.route[0] == 'inquiries'){
                          defaultAreaId = 9682;
                      } else if(pager.page.route[0] == 'opportunity'){
                          defaultAreaId = 7949;
                      } else if(pager.page.route[0] == 'applications' || pager.page.route[0] == 'forms' || pager.page.route[0] == 'interviews' || pager.page.route[0] == 'deposits'){
                          defaultAreaId = 9683;
                      } else if(pager.page.route[0] == 'person-details') {
                          if(pager.page.route[2] == 'communication-stream-details') {
                              defaultAreaId = 9681;
                          } else if (pager.page.route[2] == 'application') {
                        	  defaultAreaId = 9683;
                          }
                      } else if (pager.page.route[0] == 'contacts' || pager.page.route[0] == 'portalaccounts') {
                    	  defaultAreaId = 9681;
                      }
                      if(!$("select:visible[name=label_area]").val()){
                         if(defaultAreaId > 0) {
                             $("select:visible[name=label_area]").val(defaultAreaId).trigger("change");
                             var documentTemplateTimer = setInterval(function(){
                                 if($("select:visible[name=label_area]").parent().find(".options").find("li[rel="+defaultAreaId+"]").length > 0){
                                     $("select:visible[name=label_area]").parent().find(".options").find("li[rel="+defaultAreaId+"]").trigger('click');
                                     $("select:visible[name=label_area]").parent().find(".closer").remove();
                                     clearInterval(documentTemplateTimer);
                                 }
                             }, 1);
                         }
                         
                      } /*else if($("select:visible[name=label_area]").val()) {
                          defaultAreaId = $("select:visible[name=label_area]").val();
                          $("select:visible[name=label_area]").val(defaultAreaId).trigger("change");
                          var documentTemplateTimer = setInterval(function(){
                             if($("select:visible[name=label_area]").parent().find(".options").find("li[rel="+defaultAreaId+"]").length > 0){
                                 $("select:visible[name=label_area]").parent().find(".options").find("li[rel="+defaultAreaId+"]").trigger('click');
                                  $("select:visible[name=label_area]").parent().find(".closer").remove();
                                  clearInterval(documentTemplateTimer);
                              }
                          }, 1);
                      }*/
                      
                }
            }

            if ((controlObj.closest('form').attr('name') == 'label_new_email_form') && $('select[deferredid="'+data.id+'"]').attr('name') == 'label_template') {
            	
            } else {
            	dodropdown($(pager.activePage$().element),'select[deferredid="'+data.id+'"]');
            }
    };

    // Resolving Deffereds on call from DOM Behaviour States
    // author - Mudassar Mumtaz
    self.updateDomStateCall = function(data){
        if (data.message) {
            data = jQuery.parseJSON(data.message);
          //Resolved this Deffered to complete the calls from DOM initaiated in Control State on Form Upload
            baseView.callBacksDeferred[data.windowId].resolve(data);
        }
    };

    // grids

    self.updateGridSelect = function(data) {
        data = jQuery.parseJSON(data.message);
        data.listData = asArray(data.listData);
        // populate the select
        data.listData = jQuery.grep(
                            data.listData,
                            function(a) {
                                return $.inArray(
                                        a.id,
                                        self.grids[data.windowId].selectsFilterReduce[data.id]) != -1;
                            });

        $.each(data.listData, function(i, v) {
            data.listData[i] = {
                    id : v.id
            };
            data.listData[i]['value' + currentLanguage.charAt(0).toUpperCase()
                             + currentLanguage.slice(1)] = v[data.value];
        });
        self.grids[data.windowId].selects[data.id](data.listData);
        // activate the dropdown for grids page drop down limited the scope to grid page level
         dodropdown($(pager.activePage$().element));
    };

    self.updateFormDropDown = function(data) {
        data = jQuery.parseJSON(data.message);
        data.listData = asArray(data.listData);
        data.listData.unshift({
            id : '',
            name : ''
        });
        var urlParentId = pager.page.route[1];
        page = ko.contextFor($('#' + urlParentId + ' #' + moveInViewModel.windowId()).get(0));

        var _elementValue = page.$page.viewModel.elementValue();
        var _elementId = page.$page.viewModel.elementId();
        if(_elementValue){
            $($(pager.activePage$().element)).find("select[deferredid='"+_elementId+"']").find("option").remove();
            $.each(data.listData , function(index) {
                $($(pager.activePage$().element)).find("select[deferredid='"+_elementId+"']").append('<option value="'+data.listData[index]['id']+'">'+data.listData[index]['name']+'</option>');
            });
            //check for dropdown values if exists in dropdown or not.
            var dropDownObj = $($(pager.activePage$().element)).find("select[deferredid='"+_elementId+"']");
            var valueExists = false; // flag true when value exists in dropdown.
            if($(dropDownObj).find('option').length > 0) { // check if dropdown has values
                $(dropDownObj).find('option').each(function() { // check value in dropdown
                    if($(this).val() == _elementValue) { // if value exists
                        valueExists = true;
                    }
                })
            }
            if(valueExists == true) { // if value exists in dropdown then do this work
                $($(pager.activePage$().element)).find("select[deferredid='"+_elementId+"']").val(_elementValue);
                $($(pager.activePage$().element)).find("select[deferredid='"+_elementId+"']").parents('.formRow').append('<div class="message">'+moveInViewModel.translate('label_item_selected_automatically')+'</div>');
                var myVar = setInterval(function(){
                    $($(pager.activePage$().element)).find("select[deferredid='"+_elementId+"']").parents('.formRow').find('.message').remove();
                     clearInterval(myVar);
                }, 4000);
                dodropdown($(pager.activePage$().element));
            }
            self.formChange(true);
            //reset flag
            valueExists = false;
        }

        if(typeof page.$page.viewModel.prevUrlData != "undefined" && typeof page.$page.viewModel.prevUrlData.parentFormUrl != "undefined"){
            page.$page.viewModel.parentFormUrl(page.$page.viewModel.prevUrlData.parentFormUrl);
            page.$page.viewModel.requestUrl(page.$page.viewModel.prevUrlData.requestUrl);
            page.$page.viewModel.elementId(page.$page.viewModel.prevUrlData.elementId);
        }
   };

    /**
     * Update Order DD on custom attribute, no need to display options
     * only show the records orders with increment one
     */
    self.updateOrderSelect = function(data) {

           var data = jQuery.parseJSON(data.message);
           data.listData = asArray(data.listData);

           var sectionRecords = data.listData.length;
           var popupOption = ''; //$("<option></option>").attr("value", '').text(' ' + moveInViewModel.translate('label_please_select'));

           var controlObj = $('[callbackid="' + data.id + '"]'),
               _isSectionEdit = $(pager.activePage$().element).find('form').find('input[name="label_customattribute_id"]').val();

          if(typeof page=="undefined"){
              var urlParentId = pager.page.route[1];
              if($('#' + urlParentId + ' #' + moveInViewModel.windowId()).length > 0) {
                  page = ko.contextFor($('#' + urlParentId + ' #' + moveInViewModel.windowId()).get(0));
              } else {
                   page = ko.contextFor($('#' + data.windowId).get(0));
              }

            }

          if (ko.isObservable(page.$data.formData)){

              _formData = page.$data.formData().formData.formData.data;

          } else {
              _formData = page.$data.formData.formData.data;
          }
          
          var orderSelect = 1;
           if(_isSectionEdit==''){
               sectionRecords = sectionRecords+1;
           }
           controlObj.append(popupOption);
           for(var i=1; i<=sectionRecords; i++){
                controlObj.append($('<option></option>').attr('value', i).text(i));
                orderSelect = i;
           }
           
           if(_isSectionEdit!='') {
               orderSelect = _formData.order
           }
           var targetControlName = controlObj.attr('name');
           $('[name="'+targetControlName+'"] option[value="'+orderSelect+'"]').attr('selected', 'selected');
           controlObj.removeAttr('callbackid');
           baseView.callBacksDeferred[data.id].resolve();
    }
    /**
     * this is the wrapper funciton for updating dropdowns loaded from data in reference list
     * data is cached in local browser storage
     *
     * @param string response - service response
     * @author daniel
     */
    self.updateReferenceList = function(response) {
        var message = jQuery.parseJSON(response.message);
        if (typeof baseView[message.jsFunction] == "undefined" || typeof baseView[message.jsFunction] == undefined) {
            var functionName = '';
            var functionNames = message.jsFunction.split(".");
            functionName = window[functionNames[0]];
            for(var i = 1 ; i < functionNames.length ; i++) {
                functionName = functionName[functionNames[i]];
            }
            functionName(response);
        } else {
            baseView[message.jsFunction](response);
        }
        // set cache
        if (message.cacheKey && message.cacheKey.indexOf('referenceList/referenceList') != -1 && localStorage) {
            message.__browserCacheDate = (new Date()).getTime();
            message.__lastUpdate = moveInViewModel.referenceListLastUpdateDate;
            localStorage.setItem(message.cacheKey, JSON.stringify(message));
        }
    }

    self.searchGrid = function() {
        self.grids[data.windowId].grid.search();
    };

    /*
     * Check duplicate in leads
     */
    self.checkDuplicateLead = function(data) {
        var dataObject = jQuery.parseJSON(data.message);
        dataObject=dataObject.data.faultDatails;
        $("#dialog-modal").html(
                '<div class="dailog-ui-confirm-delete-div"><div class="delete-icon"></div>'+jQuery.i18n.prop("message_duplicate_item_confirm") + '</div>');
        $("#dialog-modal").dialog({
            height : 'auto',
            modal : true,
            title : jQuery.i18n.prop("dialog_lead_duplicate"),
            buttons : [ {
                text : jQuery.i18n.prop("button_yes"),
                click : function() {
                    // navigate to found person
                    // pager.navigate("#leads_view/entity_leads/"+dataObject.data.id+'/entity_lead_source');
                    pager.navigate("#person-details/" + dataObject.data.id);
                    $(this).dialog("close");
                    $("#dialog-modal").html('');
                    $(this).dialog("destroy");
                }
            }, {
                text : jQuery.i18n.prop("button_no"),
                click : function() {
                    $(this).dialog("close");
                    $("#dialog-modal").html('');
                    $(this).dialog("destroy");
                    $(document).find("button[kind='previous_button']").trigger('click');
                }
            } ]
        });
    };

    /**
     * fucntion to update the grid data and any select filters
     */
    self.updateGridData = function(data) {
        data = jQuery.parseJSON(data.message);
        // convert empty objects to empty string
        listData = asArray(data.data.listData);
        $.each(listData, function(key, value) {
            value.deleteMessage = ko.observable(''); // dynamic delete message
            value.dependency = ko.observable(false); // check dependency
            value.disableDelete = ko.observable(true); // disable check
            value.deleteBox = ko.observable(false); //show hide delete box
            $.each(value, function(i, val) {
                if ($.isEmptyObject(val)) {
                    listData[key][i] = '';
                }
            });
        });

        if(typeof listData.order != undefined) {
            listData.sort(function(a, b) {

                if($.isNumeric(a.order) && $.isNumeric(b.order)) {
                    return parseInt(a.order) < parseInt(b.order);
                }
                return true;
            });
        }

        self.grids[data.windowId].grid.data(listData);

        self.grids[data.windowId].selectsFilterReduce = new Array();

        // get updated data for each select filter
        $.each(self.grids[data.windowId].columns, function(i, v) {
            if (v.binding && v.binding.url) {

                if (data.data.filterReduceFields) {
                    self.grids[data.windowId].selectsFilterReduce[v.callBackId] = asArray(data.data.filterReduceFields[v.field]);
                }
                request(v.binding.url + '/' + v.callBackId
                        + '/' + data.windowId, {
                    lang : currentLanguage
                });
            }
        });
        // Make grid sortable for custom attribute grid
        self.grids[data.windowId].grid.makeGridSortable(data);
    };


    self.updateSectionData = function(data) {
        data = jQuery.parseJSON(data.message);
        self.grids[data.windowId].grid.sections()[self.grids[data.windowId].grid.sections().length-1].id = data.data.id;
    }

    /**
     * fucntion to create a grid
     */
    self.createGrid = function(data) {
        data = jQuery.parseJSON(data.message);
        // set the search columns fields for the grid
        self.grids[data.windowId].columns = asArray(data.gridConfig.columnData);
        self.grids[data.windowId].defaultSortColumn = self.grids[data.windowId].columns[1].field;

        // create observables to store the current search value
        // create an observable array to old the options for any select fields
        $.each(self.grids[data.windowId].columns, function(i, v) {
            v.searchValue = ko.observable('');

            if (v.type == 'select') {

                v.callBackId = guid();
                v.options = ko.observableArray();
                if (!self.grids[data.windowId].selects) {
                    self.grids[data.windowId].selects = new Array();
                }

                self.grids[data.windowId].selects[v.callBackId] = v.options;
            }
        });
        // make a computed value for all search fields
        self.grids[data.windowId].searchValues = ko.computed(function() {
            self.grids[data.windowId].values = new Object();
            $.each(self.grids[data.windowId].columns, function(i, v) {
                if (v.searchValue()) {
                    // if search field is select operater is equals
                    if (v.type == 'select') {
                        op = 'eq';
                    } else {
                        op = 'cn';
                    }

                    self.grids[data.windowId].values[i] = {
                            data : v.searchValue,
                            op : op,
                            field : v.field
                    };
                }
            });
            return self.grids[data.windowId].values;
        });
        // subscrribe to changes on search fields
        // post the request on change
        self.grids[data.windowId].searchValues.subscribe(function(val) {
            self.grids[data.windowId].grid.search();
        }, this);
        // this stopped working for some reason

        // self.grids[data.windowId].searchValues.extend({
        // rateLimit: 500
        // });

        // create the gid, with no data
        self.grids[data.windowId].grid = new ko.moveInGrid.viewModel({
            entityName : self.grids[data.windowId].name,
            displayNameKey : data.gridConfig.displayNameKey,
            searchValues : self.grids[data.windowId].searchValues,
            rowFunctions : data.gridConfig.rowFunctions,
            urlPrefix : data.gridConfig.urlPrefix,
            customEdit : self.grids[data.windowId].customEdit,
            windowId : data.windowId,
            data : ko.observableArray(),
            columns : ko.observableArray(self.grids[data.windowId].columns),
            actions : ko.observableArray(asArray(data.gridConfig.listActions)),
            pageSize : 50,
        });
        self.grids[data.windowId].gridActive(true);

        /**
         * Adding sections for custom grid in system admin
         * @author Mudassar Ali
         */
        $.each(asArray(data.gridConfig.sections), function(i, v) {
            v.active = ko.observable(false);
            v.confirmDelete = ko.observable(false);
            v.edit = ko.observable(false);
            v.name = ko.observable(v.name);
            v.dependency = ko.observable(false);
            v.deleteMessage = ko.observable('');
            self.grids[data.windowId].grid.sections.push(v);
        });

        // run the search if the grid does not have any selects
        if (!self.grids[data.windowId].selects) {
            self.grids[data.windowId].grid.search();
        }
    };

    // only call the list ajax call for the first display of the form
    self.gridAfterShow = function(page, callback) {
        if (!page.page.bindingContext.$data.gridActive
                || page.page.bindingContext.$data.gridActive() === false) {
            //if(page.page.bindingContext.$data.name == 'entity_general_setting') page.page.bindingContext.$data.formActive(false);
            self.makeRequest(page, callback);
        } else {
            self.grids[page.page.bindingContext.$data.pageId].grid.search();
        }
    };

    self.makeRequest = function(page, callback) {
        data = {};
        // get the parent id when editing embeded items
        if (page.page.bindingContext && page.page.bindingContext.$parents[3] && page.page.bindingContext.$parents[3].id) {
            data.parentId = page.page.bindingContext.$parents[3].id;
        }
        data.windowId = page.page.viewModel.pageId;
        data.browserTabId = browserTabId;
        url = page.page.viewModel.urlPrefix + '/' + page.page.viewModel.type;
        if (page.page.viewModel.id) {
            if(pager.page.route[pager.page.route.length - 2] == 'new' && typeof pager.page.route[pager.page.route.length - 1] != "undefined")
                url = url + '/' + pager.page.route[pager.page.route.length - 1];
            else if(pager.page.route[pager.page.route.length - 2] == 'duplicate')
                url = page.page.viewModel.urlPrefix + '/duplicate/' + pager.page.route[pager.page.route.length - 1];
            else
                url = url + '/' + page.page.viewModel.id;
        }
        $.post(url, data);
        return true;
    };

    /**
     * Recursive function to generate complete path of page for create new button to get to correct page
     * @author Mudassar Ali
     */
    self.createSubMenuPath = function (menuItem, detailPage) {
        if (menuItem.parentMenu) {
            return self.createSubMenuPath(menuItem.parentMenu, detailPage) + "/" + menuItem.name;
        }
        if (detailPage && !menuItem.parentMenu) {
            return menuItem.name + '_view';
        }
        return menuItem.name;
    }

    /**
     * Recursive function that generates menu hierachy for all submenus and further submenus if available
     * @author Mudassar Ali
     * Plus it also attaches some function and data to each menu item which is done my Simon
     * @author Simon
     */
    self.createSubMenuItems = function (v) {
        if (!v.submenuItems) {
            return;
        }
        $.each(v.submenuItems, function(smi, smv) {
            smv.pageId = guid();
            smv.parentMenu = v;
            smv.singlePageViews = ko.observableArray();
            smv.pagePath = "#" + self.createSubMenuPath(smv, false);
            if (!smv.gridTemplate) {
                smv.gridTemplate = 'moveIn4Grid';
            }

            if( smv.pagePath ==  '#system_admin/label_group') {
                smv.pagePath = '#system-admin/label_group'
            }
            

            if( smv.pagePath ==  '#system_admin/form_types') {
                smv.pagePath = '#system-admin/form-types';
            }
            if( smv.pagePath ==  '#system_admin/label_users') {
                smv.pagePath = '#system-admin/users';
            }
            if( smv.pagePath ==  '#system_admin/label_marketing_sources') {
                smv.pagePath = '#system-admin/marketing-source';
            }
            /*if( smv.pagePath ==  '#system_admin/entity_status') {
                smv.pagePath = '#system-admin/status';
            }*/
            //#system_admin/entity_form_types
            if( smv.pagePath ==  '#system_admin/entity_form_types') {
                smv.pagePath = '#system-admin/form-types';
            }
            if( smv.pagePath ==  '#system_admin/entity_lead_source_status') {
                smv.pagePath = '#system-admin/lead-source-status';
            }
            if( smv.pagePath ==  '#system_admin/entity_admission_status') {
                smv.pagePath = '#system-admin/admission-status';
            }

            if( smv.pagePath ==  '#form-admin/entity_forms') {
                smv.pagePath = '#form-admin/forms';
             }
            if( smv.pagePath ==  '#form-admin/label_portal') {
                smv.pagePath = '#form-admin/portal';
             }
            if( smv.pagePath ==  '#form-admin/entity_form_answers') {
                smv.pagePath = '#form-admin/form-answers';
             }
            if( smv.pagePath ==  '#programme-admin/entity_program_type') {
                smv.pagePath = '#programme-admin/programme-type';
             }
            if( smv.pagePath ==  '#programme-admin/entity_program') {
                smv.pagePath = '#programme-admin/programme';
             }
            if( smv.pagePath ==  '#programme-admin/entity_intake') {
                smv.pagePath = '#programme-admin/intake';
             }


            if( smv.pagePath ==  '#system_admin/label_document_repository') {
                smv.pagePath = '#system-admin/document-repository';
            }
            if( smv.pagePath ==  '#system_admin/entity_process_flow_configurations') {
                smv.pagePath = '#system-admin/milestones-stages';
            }
            if( smv.pagePath ==  '#system_admin/label_roles_rights') {
                smv.pagePath = '#system-admin/roles-rights';
            }
            if( smv.pagePath ==  '#system_admin/label_document_template') {
                smv.pagePath = '#system-admin/document-templates';
            }
            if( smv.pagePath ==  '#system_admin/label_document_types') {
                smv.pagePath = '#system-admin/document-types';
            }
            if( smv.pagePath ==  '#system_admin/entity_email_templates') {
                smv.pagePath = '#system-admin/email-template';
            }
            if( smv.pagePath ==  '#system_admin/label_email_configurations') {
                smv.pagePath = '#system-admin/email-config';
            }
            if( smv.pagePath ==  '#system_admin/label_imported_csv_files') {
                smv.pagePath = '#system-admin/imported-csv-files';
            }
            if( smv.pagePath ==  '#system_admin/label_roles_rights') {
                smv.pagePath = '#system-admin/roles-rights';
               }
            if( smv.pagePath ==  '#system_admin/modification-history') {
                smv.pagePath = '#modification-history';
            }
            if( smv.pagePath ==  '#system_admin/entity_general_setting') {
                smv.pagePath = '#system-admin/general-setting';
            }
            if( smv.pagePath ==  '#system_admin/entity_modification_history') {
                smv.pagePath = '#modification-history-contact';
            }
            if( smv.pagePath ==  '#system_admin/entity_his_export') {
                smv.pagePath = '#system-admin/his-export-form';
            }
            if (smv.pagePath == '#system_admin/label_scoring_admin') {
                smv.pagePath = '#system-admin/scoring-admin/scoring-forms'
            }
            if( smv.pagePath ==  '#system_admin/label_generated_files') {
                smv.pagePath = '#generated-pdf';
            }
            if( smv.pagePath ==  '#system_admin/label_generated_files/label_generated_csv_excel_files') {
                smv.pagePath = '#generated-csv-excel-files';
            }
            if( smv.pagePath ==  '#system_admin/entity_automation') {
                smv.pagePath = '#system-admin/process-automations';
            }
            if( smv.pagePath ==  '#system_admin/entity_form_admin') {
                smv.pagePath = '#form-admin/portal';
            }
            if( smv.pagePath ==  '#system_admin/entity_programme_admin') {
                smv.pagePath = '#programme-admin/programme-type';
            }
            
            if( smv.pagePath ==  '#system_admin/entity_fee_management') {
                smv.pagePath = '#system-admin/entity-fee-management'
            }
            if( smv.pagePath ==  '#system_admin/entity_imported_values') {
                smv.pagePath = '#system-admin/entity-imported-values'
            }
            if( smv.pagePath ==  '#system_admin/label_automated_export') {
                smv.pagePath = '#system-admin/automated-export';
            }
            if( smv.pagePath ==  '#system_admin/label_privacy_policy') {
                smv.pagePath = '#system-admin/privacy-policy-form';
            }
            if( smv.pagePath ==  '#system_admin/label_institution') {
                smv.pagePath = '#system-admin/institution';
            }
            if( smv.pagePath ==  '#reputation-admin/entity_subject_area') {
                smv.pagePath = '#reputation-admin/subject-area';
            }
            // post request for custom buttons
            smv.customButton = function() {
                data = {};
                data.windowId = smv.pageId;
                data.browserTabId = browserTabId;
                url = this.url;

                $.post(url, data);

            };
            smv.newSinglepageView = function() {
                customEdit = this.customEdit;
                urlPrefix = this.urlPrefix;
                pageId = guid();
               /* smv.singlePageViews.push({
                    singlePageViewTemplate:'singlePageViewTemplate',
                    pageId : pageId,
                    id : null,
                    urlPrefix : urlPrefix,
                    type : 'new',
                    formActive : ko.observable(false)
                });*/
                if(customEdit){

                    var menuPath = customEdit;
                }else{
                    var menuPath = self.createSubMenuPath(smv, true);
                }

                /*
                 * Code added by Farhan to change pager.navigate to return url for having open in new tab
                 */
                if(pager.page.route[0]=="label_administration"){
                    pager.navigate('#' + menuPath + '/new');
                }
                return '#' + menuPath + '/new';

            };

            smv.randomFailed = function(options) {
                type='edit';
                pv=null;
                pageviewTemplate='singlePageViewTemplate';
                if(options.page.bindingContext.$data.singlePageViewTemplate=='personViewTemplate'){
                    //only use the personViewTemplate when viewing a template
                    if(options.route[0]!='new'){
                        pageviewTemplate='personViewTemplate';

                        type='load';
                        pv= new personView();
                    }
                }
                var page = options.page;
                var route = options.route;
                urlPrefix = options.page.bindingContext.$data.urlPrefix;
                customEdit = options.page.bindingContext.$data.customEdit;
                pageId = guid();

                /*
                 * If a form has no "Name key", then "Name" key will be
                 * created and first key, which is not "ID" will be assigned
                 * to the "Name" key. It will be used as form title. @author
                 * Sheraz Saleem
                 */
                var formName = smv.name;
                if (smv.formName) {
                    formName = smv.formName;
                }
                
                // getEntityName();
                smv.singlePageViews.push({
                    pageId : pageId,
                    id : route[0],
                    name: smv.name,
                    formName :formName,
                    urlPrefix : urlPrefix,
                    customEdit : customEdit,
                    titleName : ko.observable(''),
                    tabTitleName : ko.observable(''),
                    singlePageViewTemplate:pageviewTemplate,
                    formActive : ko.observable(false),
                    submitMessage : ko.observable(false),
                    submitMessageText : ko.observable(''),
                    type : type,
                    personView : pv
                });
                page.showPage(route);
            };
            if (smv.type && smv.type == 'list') {
                smv.gridActive = ko.observable(false);
                self.grids[smv.pageId] = smv;
            } else if (smv.type && smv.type == 'edit') {
                smv.formActive = ko.observable(false);
                smv.titleName= ko.observable('');
                smv.submitMessage = ko.observable(false);
                smv.submitMessageText = ko.observable('');
            }

            if (smv.submenuItems) {
                self.createSubMenuItems(smv);
                smv.currentHref = ko.observable(smv.name + '/' + smv.submenuItems[0].name);
                smv.pagePath = smv.pagePath + '/' + smv.submenuItems[0].name;
            }
        });
    }

    self.grids = [];
    $.each(self.menuItems, function(i, v) {
        if (v.submenuItems.length) {
            v.pageId = guid();
            self.createSubMenuItems(v);
            if (v.name != "system_admin") {
                v.currentHref = ko.observable(v.name + '/' + v.submenuItems[0].name);
            } else {
                v.currentHref = ko.observable(v.name);
            }
        } else {
            v.currentHref = ko.observable(v.name);
        }
    });

    /**
     * Reset form builder page after hide and redirect to grid
     * @author: Mudassar Ali
     */
    self.resetFormPage= function(page) {
        $(page.page.element).find('button[data-mask="button_cancel"]').trigger('click', [ "redirectToDefault"]);
        $(page.page.element).find('button[kind="reset_button"]').trigger('click', [ "redirectToDefault"]);
    };

}